import React from 'react'
import {FieldViewSize} from "../../../../const";
import FieldSelectTask from "../../select-task";

type Props = {
    className   : string,
    field       : FieldSelectTask
    onClick     : () => void,
    children    : any
    size?       : any

}
const debug = false
// const debug = "FieldSelectTask_FormValueEmpty"

export default function FieldSelectTask_FormValueEmpty(props:Props) {

    debug && console.log(debug, "props=", props)

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)
    const placeholder = props.field.noValueOption ? props.field.noValueOptionLabel : props.field.placeholder

    const classes = Classes("ui5-field-form-editable dropdown-form ui5-txt-default", props.className, {
        'h-36'                      : size === FieldViewSize.DEFAULT,
        'h-28'                      : size === FieldViewSize.SMALL
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {!!props.field.noValueOptionIcon &&
                    <div className={Classes("ui5-ico-15 m-r-8", props.field.noValueOptionIcon)}/>
                }
                {placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )
}
